import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function MapsUgcIcon(props: IconProps) {
    return <Icon {...props} iconKey={"maps_ugc"}/>
}
